import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes intelligently (later utilities win).
 * Standard shadcn/ui helper used by every primitive.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * `Error.message` when the caught value is one, else a readable fallback
 * (never `"[object Object]"`). Was duplicated verbatim in the evaluations
 * `detail.tsx` and `new.tsx` route files (both catch-block `messageOf`
 * helpers) — shared here so a future route doesn't reimplement it a third time.
 */
export function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err)
}
